import getValue from './_getValue';
import root from '../root';

/**
 * @private
 *
 * @param {String} value: (optional) value to check
 *
 * @returns {Boolean}
 */
function isAddress(value = '') {
  value = value.toLowerCase();

  return value === 'address' || value === 'p.address';
}

/**
 * @private
 *
 * @param {String} value: (optional) value to check
 *
 * @returns {Boolean}
 */
function isUtmCampaign(value = '') {
  value = value.toLocaleLowerCase();
  return value === 'utm_campaign';
}


/**
 * @private
 */
const URL_PARAM = /(.+)=([^&]+)/;

/**
 * @public
 * Gets values from the URL search and store them as an object.
 *
 * @see https://gist.github.com/jherax/e6ecb05aa35eb0219525
 *
 * @param  {String} url: (optional) URL from where extract the search parameters
 * @param  {String} key: (optional) specific parameter in the url-search to extract
 * @return {Object}
 */
export default function urlParamsToObject(url = root.location.href, key) {
  let m;
  const paramsObj = {};

  url = url.split('?')[1];

  if (url) {
    url.split(/[?&]/g).forEach((param) => { // eslint-disable-line
      m = param.match(URL_PARAM);
      if (!param || !m) return true; // continue
      if (!key || key === m[1]) {
        if (isUtmCampaign(m[1])) {
          paramsObj[m[1].trim()] = m[2].split('#')[0];
        } else {
          paramsObj[m[1].trim()] = getValue(
            isAddress(m[1]) ? m[2] : m[2].split('#')[0]);
        }
      }
    });
  }

  return paramsObj;
}
